import { Component, OnInit, ViewChild } from '@angular/core';
import { MasterService } from '../master.service';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AddCategoryTypeComponent } from './add-category-type/add-category-type.component';
import { LoaderService } from 'src/app/common/loader.service';
import { PartnerTypeModel } from '../category/add-category/partnerType.model';

@Component({
  selector: 'app-category-type',
  templateUrl: './category-type.component.html',
  styleUrls: ['./category-type.component.scss']
})
export class CategoryTypeComponent implements OnInit {
  partnerTypes: PartnerTypeModel[];
  searchForm: FormGroup;
  addType;
  toggleColumn = true;
  rowData: any[];

  newAddObj: AddCategoryTypeComponent
  @ViewChild(AddCategoryTypeComponent, { static: true }) set Content(newObjRef) {
    this.newAddObj = newObjRef;
  }

  constructor(private masterService: MasterService, private formBuilder: FormBuilder
    , private router: Router, private loaderService:LoaderService) { 
    this.getFormGroup();
  }

  ngOnInit() {
    this.searchCategoryType();
    this.masterService.getPartnerTypes().subscribe(response => {
      if (response && response['result']) {
        this.partnerTypes = response['result'];
      }
    })
  }

  private getFormGroup() {
    this.searchForm = this.formBuilder.group({
      'id': new FormControl(),
      'partnerType': new FormControl(),
      'code': new FormControl(),
      'descEn': new FormControl(),
      'desc': new FormControl(),
      'codeInternational': new FormControl(),
      'codeLocal': new FormControl(),
    })
  }

  addNew() {
    this.router.navigate(['addCategoryType']);
    this.newAddObj.addTitle = true;
    this.newAddObj.editTitle = false;
  }

  hideRightDiv() {
    this.addType = false;
    this.toggleColumn = true;
  }

  searchCategoryType() {
    let saveData = {};
    saveData["master"] = this.searchForm.value;
    saveData["masterShName"] = "CATEGORY_TYPE";
    this.loaderService.display(true);
    this.masterService.searchMaster(saveData).subscribe(response => {
      this.loaderService.display(false);
      let result = response['result'];
      if (result) {
        result = result.map(item => ({
          ...item,
          pName: item.partnerType ? this.partnerTypes.find(obj => obj.partnerTypeId === item.partnerType).partnerTypeName : null
        }))
      }
      if (result) {
        this.rowData = result;
      }
    })
  }

  onRowClicked(event: any) {
    this.addType = true;
    this.toggleColumn = false;
    this.newAddObj.addTitle = false;
    this.newAddObj.editTitle = true;
    const searchData = event.data;
    this.newAddObj.addForm.patchValue({
      id: searchData.id,
      ssId: searchData.ssId,
      code: searchData.code,
      descEn: searchData.descEn,
      desc: searchData.desc,
      codeInternational: searchData.codeInternational,
      codeLocal: searchData.codeLocal
    })
  }

  reset() {
    this.searchForm.reset();
  }

}
